import React from 'react';
import PropTypes from 'prop-types';

import ModalButton from 'components/modals/modal_button';
import Modal from 'components/lib/modal';

function FbPagesSuccessModal({ onClose }) {
  return (
    <Modal className="fbPagesSuccessModal">
      <div className="fbPagesSuccessModal-container">
        <div className="fbPagesSuccessModal-header">{'Congratulations!'}</div>
        <p>Your Facebook Page(s) are connected</p>
        <p>Please contact Gladly to connect your Facebook Page(s) to an Inbox.</p>
      </div>
      <div className="fbPagesSuccessModal-footer">
        <ModalButton className="fbPagesSuccessModal-footer-confirmButton" onClick={onClose}>
          OK
        </ModalButton>
      </div>
    </Modal>
  );
}

FbPagesSuccessModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default FbPagesSuccessModal;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/modals/fb_pages_success_modal.jsx